import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { showErrorDialog } from '../../shared/utils';
import { ComplianceDashboardItem } from './compliance-dashboard.model';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class ComplianceDashboardService {
  private apiEndpoint = `${environment.apiEndpoint}/api/compliance-dashboard`;

  constructor(private http: HttpClient, private logger: NGXLogger, private apiErrorDialog: MatDialog) {}

  listComplianceDashboardItems$(): Observable<ComplianceDashboardItem[]> {
    return this.http.get<ComplianceDashboardItem[]>(this.apiEndpoint).pipe(
      catchError((error) => {
        this.logger.error(error);
        showErrorDialog(this.apiErrorDialog, error);
        return of([]);
      })
    );
  }
}
